var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02977 3.3437C10.9834 2.88543 13.0166 2.88543 14.9703 3.3437C17.7916 4.0055 19.9946 6.20843 20.6564 9.02977C21.1146 10.9834 21.1146 13.0166 20.6564 14.9703C19.9946 17.7916 17.7916 19.9946 14.9703 20.6564C13.0166 21.1146 10.9834 21.1146 9.02977 20.6564C6.20843 19.9946 4.0055 17.7916 3.3437 14.9703C2.88543 13.0166 2.88543 10.9834 3.3437 9.02976C4.0055 6.20842 6.20842 4.0055 9.02977 3.3437ZM12.2758 9.12813C12.2758 8.79676 12.0072 8.52813 11.6758 8.52813C11.3445 8.52813 11.0758 8.79676 11.0758 9.12813V12.6643C11.0758 12.8694 11.1807 13.0604 11.3538 13.1705L14.0711 14.8994C14.3507 15.0773 14.7215 14.9949 14.8994 14.7153C15.0773 14.4357 14.9949 14.0649 14.7153 13.887L12.2758 12.3349V9.12813Z",
    fill: "#8494AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f8d55fc2bf3a9e9f8808f8a2b345bddf.svg";
export { ForwardRef as ReactComponent };